
export const JPushManager = {
    setAlias(alias: string) {
    },
    removeAlias() {
    },
     getRegistrationID(): Promise<string> {
        return Promise.resolve('web');
    }

}